module.exports = __webpack_public_path__ + "static/image-slider-81b3a2e65d2ab7d00164fdb6bb25e7f1.mp4";